import { render, staticRenderFns } from "./MemQuotaPropertyPanel.vue?vue&type=template&id=c7a785cc&"
import script from "./MemQuotaPropertyPanel.vue?vue&type=script&lang=js&"
export * from "./MemQuotaPropertyPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VListItemTitle})
